module.exports = __webpack_public_path__ + "img/feature_buy_th.494e366a.png";